import { Injectable } from '@angular/core';
import {
  AbstractControlOptions,
  UntypedFormArray,
  Validators,
} from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import {
  Parameters,
  PledgeProductRead,
} from '@app/forms/subscription/definition/interface/Pledge';
import { FormConfig } from '@app/forms/subscription/definition/types/subscription';
import FormGroupArray from '@app/forms/subscription/services/FormGroupArray';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root',
})
export abstract class EaSubscriptionBuilder extends PrFormAbstract {
  generateForm(entity: PledgeProductRead & { parameters: any }, option) {
    const parameters: Parameters = {
      ...option,
    };
    let options: AbstractControlOptions = {};

    const formConfig: FormConfig<PledgeProductRead & { parameters: any }> = {
      id: [entity.id],
      type: [entity.type],
      productId: [entity.productId],
      productName: [entity.productName],
      status: [entity.status],
      parameters: this.formBuilder.group({
        maintainIncomeDuringWorkStoppage: [
          !_.isNil(entity?.parameters?.maintainIncomeDuringWorkStoppage)
            ? entity?.parameters?.maintainIncomeDuringWorkStoppage
            : null,
          Validators.required,
        ],
        maintainIncomeDuringWorkStoppageNeeds: [
          entity?.parameters?.maintainIncomeDuringWorkStoppageNeeds || [],
          !!entity?.parameters?.maintainIncomeDuringWorkStoppage
            ? Validators.required
            : Validators.nullValidator,
        ],
      }),
    };

    return this.formBuilder.group(formConfig, options);
  }
  generate(entity: any, option) {
    return FormGroupArray.generate({
      entity,
      options: option,
      formBuilder: this.formBuilder,
      generateForm: this.generateForm.bind(this),
      propertyName: 'products',
    });
  }

  get products() {
    return this.form.get('products') as UntypedFormArray;
  }

  extract() {
    return this.form.value.products;
  }
}
